export default "__VITE_ASSET__C8dgvjWa__"